import URI from 'urijs'
import { API_BASE } from 'shared/constants/Api'

export const SALARIES_LIST = (params) => URI(`${API_BASE}/api/v3/salaries/se/`).addSearch(params)
export const SALARY = (id) => `${API_BASE}/api/v3/salaries/se/${id}/`
export const SALARY_CALCULATOR = (params) => URI(`${API_BASE}/api/v3/salaries/se/calculator`).addSearch(params)
